<div class="contentArea" *ngIf="!loadingHome">
  <div class="innerContainerEstadoTramite" *ngIf="showComponent">
    <div class="primaryContent">
      <ion-grid class="ion-no-padding" [ngClass]="showErrorScreen ? 'ion-hide' : ''">
        <ion-row>
          <h2 class="title-beneficios">Beneficios de la Reforma de Pensiones</h2>
          <p class="subtitle-beneficios">Infórmate sobre los beneficios que se te otorgarán con la nueva Reforma de
            Pensiones.</p>
        </ion-row>

        <ion-row *ngIf="isMobile">
          <div class="help-container">
            <div class="help-container-header" (click)="toggleHelp()" (keydown.enter)="toggleHelp()">
              <p>¿Necesitas ayuda?</p>
              <ion-icon class="arrow" [class.open]="isOpenHelp" name="chevron-down-outline"></ion-icon>
            </div>
            <div class="help-card" *ngIf="isOpenHelp">
              <ng-container>
                <p>Solicita una Video atención con uno de nuestros ejecutivos:</p>
              </ng-container>

              <div class="help-card-button" (click)="goToVideoAtencion()" (keydown.enter)="goToVideoAtencion()">
                <a class="schedule-button">Agendar Video Atención</a>
              </div>
            </div>
          </div>
        </ion-row>

        <ion-row>
          <ng-container *ngFor="let beneficio of cardDataReformaPensiones">
            <app-card-beneficios (beneficioEmit)="onBeneficioEvent($event)" [beneficio]="beneficio"
              style="width: 100%;"></app-card-beneficios>
          </ng-container>
        </ion-row>

        <ion-row>
          <app-card-importante [tipo]="tipoBeneficios" [codigosBackBeneficiosOtorgados]="codigosBackBeneficiosOtorgados"
            style="width: 100%;"></app-card-importante>
        </ion-row>

      </ion-grid>
    </div>
    <div class="secondaryContent" *ngIf="!showErrorScreen">
      <app-right-side-info-column [data]="rightColumnData" [isHelp]="true"></app-right-side-info-column>
    </div>
  </div>
</div>

<div class="contentArea" *ngIf="loadingHome && !servsError">
  <div class="innerContainerEstadoTramite" *ngIf="showComponent">

    <div class="primaryContent">
      <ion-grid class="ion-no-padding" [ngClass]="showErrorScreen ? 'ion-hide' : ''">
        <ion-skeleton-text animated style="
            width: 60%;
            height: 25px;
            border-radius: 12px;
            margin-bottom: 23px;
          "></ion-skeleton-text>
        <ion-skeleton-text animated style="
            width: 90%;
            height: 96px;
            border-radius: 12px;
            margin-bottom: 40px;
          "></ion-skeleton-text>

        <ion-skeleton-text animated style="
            width: 50%;
            height: 24px;
            border-radius: 12px;
            margin-bottom: 3.5px;
          "></ion-skeleton-text>
        <ion-skeleton-text animated style="
            width: 90%;
            height: 96px;
            border-radius: 12px;
            margin-bottom: 48px;
          "></ion-skeleton-text>

        <ion-skeleton-text animated style="
            width: 65%;
            height: 24px;
            border-radius: 12px;
            margin-bottom: 3.5px;
          "></ion-skeleton-text>
        <ion-skeleton-text animated style="
            width: 80%;
            height: 96px;
            border-radius: 12px;
            margin-bottom: 24px;
          "></ion-skeleton-text>
      </ion-grid>
    </div>
    <div class="secondaryContent" *ngIf="!showErrorScreen">
      <ion-skeleton-text animated style="
            width: 60%;
            height: 25px;
            border-radius: 12px;
            margin-bottom: 23px;
          "></ion-skeleton-text>
      <ion-skeleton-text animated style="
            width: 90%;
            height: 96px;
            border-radius: 12px;
            margin-bottom: 40px;
          "></ion-skeleton-text>

      <ion-skeleton-text animated style="
            width: 50%;
            height: 24px;
            border-radius: 12px;
            margin-bottom: 3.5px;
          "></ion-skeleton-text>
      <ion-skeleton-text animated style="
            width: 90%;
            height: 96px;
            border-radius: 12px;
            margin-bottom: 48px;
          "></ion-skeleton-text>
    </div>

  </div>
</div>

<app-generic-error *ngIf="servsError" [ops]="errorOps" [retryAttempt]="attempt" (retryEvent)="onRetryEvent()"
  (goToEvent)="onGoToEvent()">
</app-generic-error>